'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _card_component = require('./global_components/card_component.js');

var _card_component2 = _interopRequireDefault(_card_component);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ramda = require('ramda');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BoardOfDirectorsCard = function (_React$PureComponent) {
  _inherits(BoardOfDirectorsCard, _React$PureComponent);

  function BoardOfDirectorsCard(props) {
    _classCallCheck(this, BoardOfDirectorsCard);

    return _possibleConstructorReturn(this, (BoardOfDirectorsCard.__proto__ || Object.getPrototypeOf(BoardOfDirectorsCard)).call(this, props));
  }

  _createClass(BoardOfDirectorsCard, [{
    key: 'render',
    value: function render() {

      if ((0, _ramda.isNil)(this.props.boardOfDirectors)) {
        return null;
      }
      var boardOfdirectorsList = this.props.boardOfDirectors.map(function (item) {
        return _react2.default.createElement(
          'span',
          null,
          item.partyRoleName,
          _react2.default.createElement('br', null)
        );
      });
      return _react2.default.createElement(
        _card_component2.default,
        {
          headerTitle: "Board of directors",
          headerTitleId: "boardOfDirectorsCardHeaderId",
          headerTitleLabel: "",
          headerLabel: ""
        },
        _react2.default.createElement(
          'div',
          { className: this.props.breakpoint === 1 ? "font-weight-400" : "divided-list-by-2", 'data-testid': 'board-of-directors' },
          boardOfdirectorsList
        )
      );
    }
  }]);

  return BoardOfDirectorsCard;
}(_react2.default.PureComponent);

exports.default = BoardOfDirectorsCard;